var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-file.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.9647 17.8875C41.866 17.6614 41.7277 17.4547 41.5564 17.2771L29.0564 4.7771C28.8788 4.60582 28.6721 4.46754 28.446 4.36877C28.3835 4.3396 28.3168 4.32294 28.2502 4.30002C28.0758 4.2407 27.8944 4.20497 27.7106 4.19377C27.6668 4.1896 27.6272 4.16669 27.5835 4.16669H13.0002C10.7022 4.16669 8.8335 6.03544 8.8335 8.33335V41.6667C8.8335 43.9646 10.7022 45.8334 13.0002 45.8334H38.0002C40.2981 45.8334 42.1668 43.9646 42.1668 41.6667V18.75C42.1668 18.7063 42.1439 18.6667 42.1397 18.6209C42.1296 18.4369 42.0938 18.2553 42.0335 18.0813C42.0127 18.0146 41.9939 17.95 41.9647 17.8875ZM35.0543 16.6667H29.6668V11.2792L35.0543 16.6667ZM13.0002 41.6667V8.33335H25.5002V18.75C25.5002 19.3026 25.7197 19.8325 26.1104 20.2232C26.5011 20.6139 27.031 20.8334 27.5835 20.8334H38.0002L38.0043 41.6667H13.0002Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1665 25H33.8332V29.1667H17.1665V25ZM17.1665 33.3334H33.8332V37.5H17.1665V33.3334ZM17.1665 16.6667H21.3332V20.8334H17.1665V16.6667Z",
    fill: "#797979"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxFile);
export default __webpack_public_path__ + "static/media/bx-file.a5519e3b4bce245cddf659b653f4fb57.svg";
export { ForwardRef as ReactComponent };